<mat-form-field appearance="standard"><mat-label>Tipo de empaque<span class="asterisk">*</span></mat-label>
    <mat-select (selectionChange)="onSelect($event)" [formControl]="inputFormGroup.get('description')">
        <mat-option *ngFor="let packagingType of listPackagingTypes" [value]="packagingType.description">
            {{ packagingType.description }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="inputFormGroup.get('description').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
</mat-form-field>